export enum ValidationProgress {
  Unvalidated = 0,
  ValidatingEmail = 1,
  ValidatingPhone = 2,
  Validated = 3
}
